export const REG_TYPE_ID = 'regTypeId';
export const REMOVE_REG_TYPE_ID = 'removeRegTypeId';

export const setRegTypeId = (payload) => ({
    type: REG_TYPE_ID,
    payload
});

export const removeRegTypeId = (payload) => ({
    type: REMOVE_REG_TYPE_ID,
    payload
});
